export const MixpanelConfig = {
  devToken: "eacc2d71bd5d818fed4768c641aeb284",
  prodToken: "aaf6d392bdbfdc48717cb30ff41f15b7",
  prodHost: "app.intelligems.io",
};
